import { render, staticRenderFns } from "./hair-types-v2.vue?vue&type=template&id=7caff748&scoped=true"
import script from "./hair-types-v2.vue?vue&type=script&lang=js"
export * from "./hair-types-v2.vue?vue&type=script&lang=js"
import style0 from "./hair-types-v2.vue?vue&type=style&index=0&id=7caff748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caff748",
  null
  
)

export default component.exports